import { render, staticRenderFns } from "./Menuprofil.vue?vue&type=template&id=ec4e223e&"
import script from "./Menuprofil.vue?vue&type=script&lang=js&"
export * from "./Menuprofil.vue?vue&type=script&lang=js&"
import style0 from "./Menuprofil.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fregistration-user&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports